var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonduplicatereact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.461 22H14.54c.806 0 1.461-.655 1.461-1.461v-3.634H9.593c-1.542 0-2.493-1.05-2.493-2.59V8H3.46C2.656 8 2 8.655 2 9.461V20.54C2 21.344 2.656 22 3.461 22z",
    fill: "#A3A9AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.438 16h11.124A1.44 1.44 0 0022 14.562V3.438A1.44 1.44 0 0020.562 2H9.438A1.44 1.44 0 008 3.438v11.124A1.44 1.44 0 009.438 16zM15 13a1 1 0 01-1-1v-1.5a.5.5 0 00-.5-.5H12a1 1 0 110-2h1.5a.5.5 0 00.5-.5V6a1 1 0 112 0v1.5a.5.5 0 00.5.5H18a1 1 0 110 2h-1.5a.5.5 0 00-.5.5V12a1 1 0 01-1 1z",
    fill: "#A3A9AE"
  })));
}
export default SvgButtonduplicatereact;